// extracted by css-extract-rspack-plugin
export default {"VisitorStatsTable":"VisitorStatsTable-evWLTd","visitorStatsTable":"VisitorStatsTable-evWLTd"};